import { createFileRoute } from "@tanstack/react-router";
import DealeriVerificati from "@/pages/DealeriVerificati";
import { routeHead } from "@/lib/seo/route-head";
import { loadVerifiedDealers } from "@/lib/seo/verified-dealers-seo";

export const Route = createFileRoute("/de/verified-dealers/")({
  head: () => routeHead("/de/verified-dealers/"),
  loader: () => loadVerifiedDealers("DE"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealeriVerificati />
  );
}
